import React from 'react';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoServicesStats } from '../../../../contexts/ZitoneoContentContext';
import SidebarStatsSection from '../../../../components/sideBar/SidebarStatsSection';

/**
 * Renders the current category's service statistics in the sidebar.
 * @returns A sidebar section with translated category statistics.
 */
const SidebarCategory = () => {
    const translate = useTranslate();
    const {
        totalServicesInCategory,
        selectedServicesInCategory,
        servicesWithMultipleInstancesInCategory,
        totalAttributeDefinitionsInCategory,
        totalFilledAttributeFilledInCategory,
    } = useZitoneoServicesStats();

    const stats = [
        {
            value: selectedServicesInCategory,
            label: translate('services_selected'),
        },
        {
            value: totalServicesInCategory,
            label: translate('total_services'),
        },
        {
            value: servicesWithMultipleInstancesInCategory,
            label: translate('services_with_multiple_setups'),
        },
        {
            value: (
                <>
                    {totalFilledAttributeFilledInCategory}{' '}
                    <span className='--smaller'>
                        / {totalAttributeDefinitionsInCategory}
                    </span>
                </>
            ),
            label: translate('filled_attributes'),
        },
    ];

    return <SidebarStatsSection title='this_category' stats={stats} />;
};

export default SidebarCategory;
